export const canCreateJobs = (member, teamMembers) => {
  const hasWorkspacePermission = member.hasPermission('JOB_CREATE')
  const hasTeamPermission = teamMembers.reduce(
    (prev, curr) => curr.hasPermission('CREATE_TEAM_JOBS') || prev,
    false
  )
  return hasWorkspacePermission || hasTeamPermission
}
